import SendPurchaseTokenError from './SendPurchaseTokenError';
class ChannelIsNotSupported extends SendPurchaseTokenError {
    channel;
    constructor(channel, options) {
        super('Channel is not supported', options);
        this.channel = channel;
    }
}
export default ChannelIsNotSupported;
